// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"f46fd727","703":"f700e4f4"}[chunkId] + ".chunk.js";
};